module.exports = __webpack_public_path__ + "img/pic18.db13546f.png";